export const spaceTokensCommon = {
  grid: {
    value: 4,
    unit: 'px'
  },
  space: {
    none: {
      value: 0,
      unit: 'px'
    },
    '3xs': {
      value: 0.5,
      unit: 'px'
    },
    xxs: {
      value: 1,
      unit: 'px'
    },
    xs: {
      value: 2,
      unit: 'px'
    },
    s: {
      value: 3,
      unit: 'px'
    },
    m: {
      value: 4,
      unit: 'px'
    },
    l: {
      value: 6,
      unit: 'px'
    },
    xl: {
      value: 8,
      unit: 'px'
    },
    xxl: {
      value: 10,
      unit: 'px'
    },
    '3xl': {
      value: 12,
      unit: 'px'
    },
    hugem: {
      value: 14,
      unit: 'px'
    },
    hugel: {
      value: 16,
      unit: 'px'
    },
    hugexl: {
      value: 18,
      unit: 'px'
    },
    hugexxl: {
      value: 20,
      unit: 'px'
    } // 80px

  }
};
//# sourceMappingURL=spaceCommon.js.map